import React, { useState, useEffect } from "react";
import DashboardCarousel from "../../../Components/layouts/dashboard/dashboardCarousel/DashboardCarousel";
import CreatedBootcampsCarousel from "../../../Components/layouts/CreatedBootcamps/CreatedBootcampsCarousel/CreatedBootcampsCarousel";
import StudentDashboardCrousel from "../../../Components/layouts/StudentDashboard/StudentDashboardCrousel";
import DashCard from "../../../Components/share/cards/DashCard";
import { BtnAlternative } from "../../../Components/share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";

function MyBootCamp() {
    const [courses, setCourses] = useState();
    const [allCourses, setAllCourses] = useState();
    const [sliderIndex, setSliderIndex] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    useEffect(() => {
        allCourse.reFetch();
    }, [pagination]);

    const currentCourse = useFetch({
        method: "GET",
        url: "BootCampService/user_current_bootcamp",
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });
    const allCourse = useFetch({
        method: "GET",
        url: "BootCampService/user_all_bootcamp",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setAllCourses,
    });

    return (
        <div>
            <h4 className=" text-[3rem] text-black-prim font-bold mb-16 mt-5">
                دوره‌های جاری
            </h4>
            <div className="w-4/5 text-center mx-auto ">
                <StudentDashboardCrousel courses={courses?.results} />
            </div>
            <h4 className="text-[2rem] text-black-prim font-bold mb-16 mt-10">
                همه دوره‌ها
            </h4>
            <div className=" w-full mx-auto CreatedBootcamps">
                <CreatedBootcampsCarousel
                    sliderIndex={sliderIndex}
                    setSliderIndex={setSliderIndex}
                    courses={allCourses?.results}
                />
            </div>
        </div>
    );
}

export default MyBootCamp;
const course = [
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 20,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 50,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 80,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 0,
    },
];
